import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Link } from 'react-router-dom';
import _ from 'lodash';
import { trackNow } from 'shared/models/analytic';
import {
  getSubstitutionOptions,
  updateStatus,
  chooseSubstitution
} from './actions';
import Summary from './summary';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import SubstitutionOptions from './options';
import SubstitutionProduct from './product';
import BackArrowIcon from 'images/back-arrow.svg?react-svg';

class SubstitutionDetail extends React.Component {
  componentDidMount() {
    const sku = this.props.item.sku_id;

    if (this._getList().length === 0) {
      this.props.getSubstitutionOptions(sku).then(() =>
        trackNow('Substitution Products Viewed', {
          sku,
          length: this._getList().length
        })
      );
    }

    this.props.updateStatus('Editing');
  }

  _getList() {
    return this.props.options[this.props.item.sku_id] || [];
  }

  render() {
    const {
      item,
      baseUrl,
      optionsLoading,
      chooseSubstitution,
      currentSubstitution
    } = this.props;
    const list = this._getList();
    const defaultQty = currentSubstitution
      ? currentSubstitution.quantity
      : item.quantity - (item.stock_level || 0);

    return (
      <Fragment>
        <View margin="sm" className="substitutions-detail__summary-container">
          <div className="substitutions-detail__summary">
            <View padding="sm">
              <View margin="sm">
                <Text title weight="bold" size="xs">
                  Choosing a Substitution for
                </Text>
                <hr className="light" />
              </View>
              <Summary item={item} />
            </View>
          </div>
        </View>

        <div className="substitutions-detail__content-container">
          <Route
            exact
            path="/substitution/:order_id/:sku_id"
            render={({ match, history, location }) => (
              <Fragment>
                <BackArrow
                  history={history}
                  location={location}
                  to={`/substitution/${match.params.order_id}`}
                />
                <SubstitutionOptions
                  list={list}
                  loading={optionsLoading}
                  baseUrl={baseUrl}
                  chooseSubstitution={newItem => {
                    chooseSubstitution(item, newItem, defaultQty);
                    trackNow('Substitution Chosen', {
                      original_sku: item.sku_id,
                      replacement_sku: newItem.sku_id,
                      qty: defaultQty,
                      page: 'List'
                    });
                    history.push({
                      state: { to: 'overview' },
                      pathname: `/substitution/${match.params.order_id}`
                    });
                  }}
                />
              </Fragment>
            )}
          />

          <Route
            path="/substitution/:order_id/:sku_id/:replacement_sku_id"
            render={({ match, history, location }) => {
              const product = _.find(
                list,
                p => p.sku_id === match.params.replacement_sku_id
              );

              return (
                <Fragment>
                  <BackArrow
                    history={history}
                    location={location}
                    to={`/substitution/${match.params.order_id}/${match.params
                      .sku_id}`}
                  />
                  <SubstitutionProduct
                    product={product}
                    defaultQty={defaultQty}
                    chooseSubstitution={qty => {
                      chooseSubstitution(item, product, qty);
                      trackNow('Substitution Chosen', {
                        original_sku: item.sku_id,
                        replacement_sku: product.sku_id,
                        qty,
                        page: 'Detail'
                      });
                      history.push({
                        state: { to: 'overview' },
                        pathname: `/substitution/${match.params.order_id}`
                      });
                    }}
                  />
                </Fragment>
              );
            }}
          />
        </div>
      </Fragment>
    );
  }
}

function BackArrow({ to, history, location }) {
  function handleClick(e) {
    // go back instead of following link to preserve scroll position
    if (location.state && location.state.from) {
      e.preventDefault();
      history.goBack();
    }
  }

  return (
    <View padding="md" className="substitutions-detail__back-arrow">
      <Link to={to} onClick={handleClick}>
        <BackArrowIcon />
      </Link>
    </View>
  );
}

const ConnectedSubstitutionDetail = connect(
  state => ({
    options: state.substitutions.options,
    optionsLoading: state.substitutions.optionsLoading
  }),
  { getSubstitutionOptions, updateStatus, chooseSubstitution }
)(SubstitutionDetail);

export default ConnectedSubstitutionDetail;



// WEBPACK FOOTER //
// ./shared/components/substitutions/detail.js